var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 8,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1.5 1.625 5 5 5-5",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgDownArrow as ReactComponent };
export default "data:image/svg+xml;base64,dmFyIFJlYWN0ID0gcmVxdWlyZSgncmVhY3QnKTsKCmZ1bmN0aW9uIERvd25BcnJvdyAocHJvcHMpIHsKICAgIHJldHVybiBSZWFjdC5jcmVhdGVFbGVtZW50KCJzdmciLHByb3BzLFJlYWN0LmNyZWF0ZUVsZW1lbnQoInBhdGgiLHsiZCI6Ik0xLjUgMS42MjVMNi41IDYuNjI1TDExLjUgMS42MjUiLCJzdHJva2UiOiJ3aGl0ZSIsInN0cm9rZVdpZHRoIjoiMiIsInN0cm9rZUxpbmVjYXAiOiJyb3VuZCIsInN0cm9rZUxpbmVqb2luIjoicm91bmQifSkpOwp9CgpEb3duQXJyb3cuZGVmYXVsdFByb3BzID0geyJ3aWR0aCI6IjEzIiwiaGVpZ2h0IjoiOCIsInZpZXdCb3giOiIwIDAgMTMgOCIsImZpbGwiOiJub25lIn07Cgptb2R1bGUuZXhwb3J0cyA9IERvd25BcnJvdzsKCkRvd25BcnJvdy5kZWZhdWx0ID0gRG93bkFycm93Owo=";